import React, { useState, useEffect } from 'react';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { getCountryNameByCountryCode } from '@/pages/intelligence/utils/commonUtils';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { useIntl } from 'umi';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';

interface CountriesShareColumnType {
  countriesShareType: string;
  localizedCountryName?: Function; // 自定义翻译国家函数
  tipText?: any;
  showImg?: boolean;
  firstLineName?: any;
}

export const CompanyCountriesShareCloums = (params: CountriesShareColumnType) => {
  const {
    countriesShareType = 'market',
    localizedCountryName,
    tipText,
    showImg,
    firstLineName,
  } = params;

  const { formatMessage } = useIntl();
  // 增加纯国家列表以用来简称匹配全称用
  const [regionsCountries, setRegionsCountries] = useState<any>([]);
  // 获取全局国家地区数据
  const { regionOptions } = useMarketFilterApi({});

  useEffect(() => {
    setRegionsCountries(regionOptions);
  }, [regionOptions]);

  const getDbiCountryFlag = (market: string) => {
    if (['total'].includes(market)) {
      return getDataSourceIcon(market);
    }
    return getCountryFlag(market);
  };

  const shouldShowCountryImg = (market: string) => {
    const isGlobalOrGlobalWoChina = ['global', 'global_wo_china'].includes(market);
    return isGlobalOrGlobalWoChina || (market !== 'Others' && countriesShareType === 'market');
  };

  const getLocalizedCountryName = (options: any) => {
    const { cvm, localizedFunction, regionsCountries, countriesShareType } = options;
    const marketLower = typeof cvm?.market === 'string' ? cvm.market.toLowerCase() : undefined;
    const allowedMarkets = ['global', 'global_wo_china', 'total', 'others'];

    if (allowedMarkets.includes(marketLower)) {
      return formatMessage({
        id: `dbi_${marketLower}`,
        defaultMessage: cvm?.market,
      });
    }

    if (localizedFunction) {
      return localizedFunction(cvm);
    }

    return getCountryNameByCountryCode(regionsCountries, cvm?.market, countriesShareType);
  };

  return {
    key: 'app_id',
    header: formatMessage({ id: `dbi_countries` }),
    width: 200,
    align: 'left',
    render: (cvm: any) => {
      const market = cvm?.market;
      const showCountryImg = showImg === false ? false : shouldShowCountryImg(market);
      const countryName = getLocalizedCountryName({
        cvm,
        localizedFunction: localizedCountryName,
        regionsCountries,
        countriesShareType,
      });
      if (cvm?.region === 'Total' || cvm?.name === 'total') {
        // 第一行名称
        return (
          <>
            <span className="countries-text">
              {formatMessage({ id: firstLineName ? firstLineName : 'dbi_detail_table_total' })}
            </span>
            {tipText && (
              <div style={{ marginLeft: 8, display: 'inline-flex', verticalAlign: 'middle' }}>
                <TipContext AWidth={400} tipText={formatMessage({ id: tipText })} />
              </div>
            )}
          </>
        );
      }

      return (
        <div className="table-countries">
          {showCountryImg && <img src={getDbiCountryFlag(market)} className="countries-img" />}
          <span className="countries-text">{countryName}</span>
        </div>
      );
    },
  };
};
